import * as React from 'react';
import * as _ from 'lodash';
import Pager from './../../PageLayout/Pager2';
import { getFeatureImage } from './../../../utilities/helpers';
import { bkgImage } from './../../../utilities/helpers';
import { cutText } from './../../../utilities/helpers';
import { replaceLeftSpaces } from './../../../misc';
import classNames from 'classnames';
import * as helpers from './../../../utilities/helpers';
import BlueDropDown from './../../PageLayout/DropDowns/BlueDropDown';
export default function () {
    function onChange1(selectedGroupHeader, e) {
        this.props.setGroupsTerm(e.target.value);
    }
    function onClick2(selectedGroupHeader, gh, ghIndex) {
        this.props.selectFeaturesGroup(gh, !gh.isSelected);
    }
    function repeatGh3(selectedGroupHeader, gh, ghIndex) {
        return React.createElement('li', {
            'className': classNames('assign-sidebar-list__item', { 'assign-sidebar-list__item--active': gh.isSelected }),
            'key': gh.id,
            'onClick': onClick2.bind(this, selectedGroupHeader, gh, ghIndex)
        }, React.createElement('div', {
            'className': 'assign-sidebar-list__item-image',
            'style': { 'backgroundImage': bkgImage(helpers.getFeatureGroupIconURL(gh.name, true)) }
        }), React.createElement('span', { 'className': 'assign-sidebar-list__item-title' }, replaceLeftSpaces(gh.name, '\xB7')));
    }
    function onClick4(selectedGroupHeader, f, fIndex) {
        this.props.markFeatureChecked(f, !f.checked);
    }
    function onClick5(selectedGroupHeader, f, fIndex, filter, filterIndex) {
        this.props.markFeatureFilterForDeletion(f.id, filter.filterValueId, !filter.markedForDeletion);
    }
    function repeatFilter6(selectedGroupHeader, f, fIndex, filter, filterIndex) {
        return React.createElement('li', {
            'className': 'assign-filters__filter',
            'style': {
                'textDecoration': filter.markedForDeletion ? 'line-through' : '',
                color: filter.markedForDeletion ? 'red' : ''
            },
            'key': filter.filterValueId
        }, '\r\n                ', filter.filterValue, '\r\n                ', React.createElement('button', {
            'className': 'assign-filters__filter-close',
            'onClick': onClick5.bind(this, selectedGroupHeader, f, fIndex, filter, filterIndex)
        }));
    }
    function repeatI7(selectedGroupHeader, f, fIndex, i, iIndex) {
        return React.createElement('li', {
            'className': 'assign-filters__filter assign-filters__filter--empty',
            'key': i
        });
    }
    function repeatF8(selectedGroupHeader, f, fIndex) {
        return React.createElement('li', {
            'className': 'assign-feature',
            'key': f.id
        }, React.createElement('div', { 'className': 'assign-features__item' }, React.createElement('div', {
            'className': 'assign-card__checkbox',
            'onClick': onClick4.bind(this, selectedGroupHeader, f, fIndex)
        }, React.createElement('div', { 'className': 'ui-svg-checkbox' }, React.createElement('div', { 'className': 'ui-svg-checkbox__icon' }, React.createElement('svg', {
            'className': 'ui-svg-checkbox__icon-circle',
            'height': '30',
            'width': '30'
        }, React.createElement('circle', {
            'cx': '15',
            'cy': '15',
            'r': '12.5',
            'stroke': '#979797',
            'strokeWidth': '3',
            'fill': '#ffffff'
        })), f.checked ? React.createElement('div', {
            'className': 'ui-svg-checkbox__icon-checked-icon',
            'key': '2385'
        }) : null), React.createElement('div', { 'className': 'ui-svg-checkbox__text' }))), React.createElement('div', {
            'className': 'assign-features__item-image',
            'style': { 'backgroundImage': bkgImage(getFeatureImage(f)) }
        }), React.createElement('div', { 'className': 'assign-features__item-text' }, cutText(f.noGroupName, 25))), !this.props.areFeaturesFiltersCollapsed ? React.createElement('div', {
            'className': 'assign-feature__filters',
            'key': '2839'
        }, React.createElement.apply(this, [
            'ul',
            { 'className': 'assign-filters' },
            _.map(f.filters, repeatFilter6.bind(this, selectedGroupHeader, f, fIndex)),
            _.map(_.range(Math.max(0, Math.min(6, 6 - f.filters.length))), repeatI7.bind(this, selectedGroupHeader, f, fIndex))
        ])) : null);
    }
    function onItemClick9(selectedGroupHeader, value) {
        this.props.setItemsPerPage(value);
    }
    function scopeSelectedGroupHeader10() {
        var selectedGroupHeader = this.props.selectedGroupHeader;
        return React.createElement('div', { 'className': 'app-content-wrapper2' }, React.createElement('div', { 'className': 'app-content-main' }, React.createElement('aside', { 'className': 'assign-sidebar' }, React.createElement('div', { 'className': 'assign-sidebar-search' }, React.createElement('input', {
            'type': 'text',
            'className': 'ui-input ui-input--gray3',
            'placeholder': 'Search',
            'value': this.props.groupsTerm,
            'onChange': onChange1.bind(this, selectedGroupHeader)
        })), React.createElement.apply(this, [
            'ul',
            { 'className': 'assign-sidebar-list' },
            _.map(this.props.groupHeaders, repeatGh3.bind(this, selectedGroupHeader))
        ])), React.createElement('div', { 'className': 'assign-container' }, React.createElement.apply(this, [
            'ul',
            { 'className': classNames('assign-features', { 'assign-features--with-filters': !this.props.areFeaturesFiltersCollapsed }) },
            _.map(this.props.groupFeatures, repeatF8.bind(this, selectedGroupHeader))
        ]), React.createElement('div', {}, this.props.totalPages > 1 || this.props.itemsPerPage !== '50' ? React.createElement(BlueDropDown, {
            'items': [
                '50',
                '100',
                '200',
                '500'
            ],
            'onItemClick': onItemClick9.bind(this, selectedGroupHeader),
            'selectedItem': this.props.itemsPerPage,
            'key': '3776'
        }) : null, this.props.totalPages > 1 ? React.createElement(Pager, {
            'totalPages': this.props.totalPages,
            'pageClick': this.handlePaginate,
            'page': this.props.page,
            'key': '4018'
        }) : null))));
    }
    return scopeSelectedGroupHeader10.apply(this, []);
}